/* eslint-disable import/no-anonymous-default-export */
import * as Types from "./navmode.type";

interface INavMode {
  mode: string;
  school: null | object;
}

const initialState: INavMode = {
  mode: null,
  school: null,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case Types.CHANGE_ACTIVE_NAV:
      const { mode } = action.payload;
      return {
        ...state,
        mode,
      };
    case Types.CHANGE_ACTIVE_SCHOOL:
      const { school } = action.payload;
      return {
        ...state,
        school,
      };
    case Types.REHYDRATE_NAV_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
